<script>
    import { TimeFormat } from 'api/moment'
    import { serverDateTime } from 'store/server'
    import { isInputToggled, isWaterMark, isPlayer, isHelp, isPhone } from 'store/hud'
    import keys from 'store/keys'
    import keysName from 'json/keys.js'
    import { charWanted, charMoney, charBankMoney, charFractionID, charOrganizationID, charData } from 'store/chars'
    import CustomKey from './Key.svelte'
    import { format } from 'api/formatter'
    import CountUp from 'api/countup';
    import { weatherName, formatTime, getWeatherIdToName } from '../phonenew/components/weather/data'
    export let phoneNotification;
    export let mapwidth;
    export let marginhun;

    import { formatMessage } from "@/views/player/hudevo/phonenew/components/messages/data";

    let selectCharData = $charData;

    // export let SafeSone;

    let isWorld = true;
    window.hudStore.isWorld = (value) => isWorld = value;

    let direction = "NE";
    window.hudStore.direction = (value) => direction = value;

    let greenZone = false;
    window.hudStore.greenZone = (value) => greenZone = value;

    let bodycam = false;
    window.hudStore.bodycam = (value) => bodycam = value;

    let street = "";
    window.hudStore.street = (value) => street = value;

    let area = "";
    window.hudStore.area = (value) => area = value;

    
    let polygon = 0;
    window.hudStore.polygon = (value) => polygon = value;

    let radio = 0;
    window.hudStore.radio = (value) => radio = value;

    
    // ID игрока и онлайн живут в store/server и рисуются в бренд-блоке (lchud).
    // Здесь они не выводятся — прежний перехват сеттеров только затирал значения.

    let improvementTime = -1;
	window.hudStore.setImprovementTime = (value) => improvementTime = value;

    let seconds = 0;
    let timer;
    let isRunning = false;

    function start() {
        if (!isRunning) {
        const startTime = Date.now() - seconds * 1000;
        timer = setInterval(() => {
            seconds = Math.floor((Date.now() - startTime) / 1000);
        }, 100);
        isRunning = true;
        }
    }

    function stop() {
        clearInterval(timer);
        isRunning = false;
    }

    function reset() {
        clearInterval(timer);
        seconds = 0;
        isRunning = false;
    }
</script>

<div class="magicnotimap" style="width: {mapwidth + marginhun}px">
    <!-- {#if mapwidth > 0} -->
        {#if phoneNotification}
            <div class="blocknotisms" style="width: {mapwidth}px">
                <div class="headbnsms">
                    <img src="{phoneNotification.Avatar}" alt=""/> <!--{phoneNotification.Avatar}-->
                    <div class="hinfo">
                        <h1>Новое сообщение</h1>
                        <p>{phoneNotification.Name}</p> <!--{phoneNotification.Name}-->
                    </div>
                    <div class="icon">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.9905 3.30884L10.3659 7.99243L16 11.742V3.4144C16 3.3784 15.9963 3.34328 15.9905 3.30884ZM9.85875 8.41471L9.14972 9.00512C8.81662 9.28249 8.40831 9.42118 8.00003 9.42118C7.59175 9.42118 7.18341 9.28249 6.85034 9.00512L6.14131 8.41471L0 12.5019V12.5861C0 12.9348 0.283781 13.2186 0.632563 13.2186H15.3674C15.7162 13.2186 16 12.9348 16 12.5861V12.5019L9.85875 8.41471Z" fill="white"/>
                            <path d="M15.3697 2.78174H0.63025C0.540937 2.78208 0.502281 2.89586 0.570906 2.95302L6.36094 7.77439L6.363 7.77611L7.25509 8.51896C7.68672 8.87839 8.31331 8.87839 8.74494 8.51896L15.4291 2.95302C15.4977 2.89583 15.459 2.78205 15.3697 2.78174ZM0.00953125 3.30874C0.00340409 3.3436 0.000215795 3.37891 0 3.4143L0 11.7419L5.63409 7.9923L0.00953125 3.30874Z" fill="white"/>
                        </svg>  
                    </div>
                </div>
                <div class="textsms">
                    <p>{@html formatMessage (phoneNotification.Text)}</p><!--{@html formatMessage (phoneNotification.Text)}-->
                </div>
            </div>
        {/if}
        {#if improvementTime > 0}
            <div class="hudevo__improvements">
                <img src="/src/views/player/hudevo/images/improvement.svg" alt="">
                <p>{ improvementTime }</p>
            </div>
        {/if}
        {#if bodycam}
        <div class="bodicammaj" style="width: {mapwidth}px">
            <div class="iconbc">
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.75 8.4375H6.09375C5.3171 8.4375 4.6875 9.0671 4.6875 9.84375V20.1562C4.6875 20.9329 5.3171 21.5625 6.09375 21.5625H18.75C19.5267 21.5625 20.1562 20.9329 20.1562 20.1562V9.84375C20.1562 9.0671 19.5267 8.4375 18.75 8.4375Z" fill="#939599"/>
                    <path d="M25.3125 10.3126V19.6876C25.3126 19.7701 25.2911 19.8513 25.2499 19.9228C25.2088 19.9944 25.1495 20.0539 25.0781 20.0954C25.0068 20.1362 24.9259 20.1573 24.8438 20.1563C24.7617 20.1567 24.6809 20.1357 24.6094 20.0954L21.0938 18.0704V11.9297L24.6094 9.90475C24.6813 9.86552 24.7619 9.84497 24.8438 9.84497C24.9256 9.84497 25.0062 9.86552 25.0781 9.90475C25.1495 9.94619 25.2088 10.0057 25.2499 10.0773C25.2911 10.1489 25.3126 10.23 25.3125 10.3126Z" fill="#939599"/>
                </svg>
            </div>
            <div class="infobc">
                <h1>bodycam #11</h1> <!--{selectCharData.UUID}-->
                <p>Rec from 2025-07-22 17:23:34</p>
                <p>{seconds} c начала записи</p> <!--{seconds}-->
            </div>
            <div class="zapbc">
                <span></span>
            </div>
        </div>
        {/if}
        {#if greenZone}
            <div class="blocknm" style="width: {mapwidth}px">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="#58DE80"></path>
                    <path d="M7.64699 15.8822C7.335 15.8821 7.0358 15.7581 6.81522 15.5375L4.46228 13.1845C4.24798 12.9627 4.1294 12.6655 4.13208 12.357C4.13476 12.0485 4.25849 11.7535 4.47662 11.5353C4.69474 11.3172 4.98982 11.1935 5.29828 11.1908C5.60675 11.1881 5.90393 11.3067 6.12581 11.521L7.58052 12.9757L13.8123 5.70572C13.9109 5.58268 14.0333 5.48074 14.1721 5.40593C14.3109 5.33113 14.4634 5.285 14.6204 5.27027C14.7774 5.25555 14.9357 5.27255 15.086 5.32024C15.2363 5.36793 15.3755 5.44536 15.4953 5.54791C15.6151 5.65046 15.713 5.77605 15.7833 5.9172C15.8536 6.05836 15.8948 6.21221 15.9045 6.3696C15.9141 6.52699 15.892 6.68472 15.8395 6.83341C15.787 6.9821 15.7051 7.11871 15.5988 7.23513L8.53993 15.4704C8.43049 15.6005 8.29374 15.7048 8.1394 15.7759C7.98507 15.8471 7.81694 15.8834 7.64699 15.8822Z" fill="#1E1E1E"></path>
                </svg>                
                <p>Вы вошли в зелёную зону!</p>                   
            </div>
        {:else}
            <div class="blocknm" style="width: {mapwidth}px">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.6025 14.658L11.61 3.44989C11.4408 3.17581 11.2044 2.94946 10.9233 2.79229C10.6422 2.63511 10.3255 2.55232 10.0034 2.55176C9.68134 2.5512 9.36443 2.63288 9.08274 2.78907C8.80104 2.94526 8.56389 3.17078 8.39374 3.44427L1.38999 14.6711C1.22715 14.9567 1.14154 15.2798 1.1416 15.6086C1.14167 15.9374 1.2274 16.2604 1.39036 16.546C1.55331 16.8315 1.78786 17.0697 2.07089 17.2369C2.35391 17.4042 2.67565 17.4948 3.00437 17.4999H16.9956C17.3256 17.4946 17.6484 17.4032 17.9321 17.2347C18.2158 17.0661 18.4505 16.8264 18.6129 16.5391C18.7753 16.2519 18.8598 15.9272 18.858 15.5972C18.8561 15.2672 18.7681 14.9434 18.6025 14.658Z" fill="#F21626"></path>
                    <path d="M9.42936 11.6399L9.26311 9.1549C9.23061 8.6549 9.05999 7.84678 9.44186 7.44053C9.73249 7.12803 10.4206 7.07428 10.6294 7.5074C10.8069 8.01636 10.8461 8.56331 10.7431 9.0924L10.5206 11.6505C10.511 11.8913 10.4583 12.1284 10.365 12.3505C10.3282 12.4224 10.2725 12.4829 10.2039 12.5254C10.1353 12.5679 10.0563 12.5908 9.97557 12.5916C9.89485 12.5924 9.81543 12.5712 9.74592 12.5301C9.67642 12.4891 9.61947 12.4298 9.58124 12.3587C9.49328 12.1285 9.44203 11.886 9.42936 11.6399ZM10.005 15.0543C9.8079 15.0532 9.61863 14.977 9.47571 14.8413C9.33278 14.7056 9.24693 14.5205 9.23562 14.3238C9.22431 14.127 9.2884 13.9333 9.41484 13.7821C9.54128 13.6309 9.72057 13.5336 9.91624 13.5099C10.0214 13.4972 10.128 13.5061 10.2295 13.5362C10.331 13.5663 10.4253 13.6169 10.5065 13.6848C10.5877 13.7527 10.6542 13.8366 10.7018 13.9312C10.7493 14.0258 10.777 14.1291 10.7831 14.2348C10.7891 14.3405 10.7735 14.4464 10.7371 14.5458C10.7007 14.6452 10.6443 14.7361 10.5714 14.8129C10.4984 14.8897 10.4106 14.9507 10.3132 14.9923C10.2158 15.0338 10.1109 15.0549 10.005 15.0543Z" fill="white"></path>
                </svg>                             
                <p>Вы вышли из зелёной зоны!</p>                   
            </div>
        {/if}
    <!-- {/if} -->
</div>
<div class="bottomgps">
    {#if greenZone && mapwidth > 0}
            <div class="magicZZ" style="margin-left: -{mapwidth}px">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_8_151)">
                    <path d="M10.808 1.42695L6.10108 0.0148363C6.03518 -0.00494544 5.96491 -0.00494544 5.89901 0.0148363L1.19196 1.42695C1.11955 1.44867 1.05607 1.49317 1.01094 1.55382C0.96581 1.61448 0.941438 1.68807 0.941437 1.76367V6.94139C0.941437 7.61484 1.21409 8.30424 1.75176 8.99041C2.16241 9.51448 2.73056 10.0407 3.44037 10.5545C4.6328 11.4177 5.80699 11.9472 5.8564 11.9693C5.90158 11.9895 5.95053 12 6.00005 12C6.04956 12 6.09851 11.9895 6.14369 11.9693C6.19308 11.9472 7.36725 11.4177 8.55968 10.5545C9.26948 10.0407 9.83761 9.51448 10.2483 8.99041C10.786 8.30426 11.0586 7.61487 11.0586 6.94139V1.76367C11.0586 1.68807 11.0342 1.61447 10.9891 1.55381C10.9439 1.49315 10.8805 1.44866 10.808 1.42695Z" fill="#74E662"></path>
                    </g>
                    <defs>
                    <clipPath id="clip0_8_151">
                    <rect width="12" height="12" fill="white"></rect>
                    </clipPath>
                    </defs>
                </svg>
                <p>БЕЗОПАСНО</p>
            </div>
    {/if}
</div>
